import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const reviews = [{
  name: 'Andreea M.',
  text: "An absolutely magical experience. Elena is incredibly skilled – the massage was the best I've, ever, had. The setting, the Saxon barn, is breathtaking, and the attention to detail is remarkable. We'll definitely be coming back.",
  date: '2 months ago'
}, {
  name: 'Thomas K.',
  text: "What a hidden gem in Transylvania! The sauna, jacuzzi, and hot tub surrounded by the hills – pure bliss. Everything is beautifully maintained and the atmosphere is so peaceful. A must-visit if you're in the area.",
  date: '3 months ago'
}, {
  name: 'Maria D.',
  text: "Elena's expertise really shows she tailored the treatment perfectly to what I needed. The Zen Barn Ritual was an unforgettable experience. The whole space feels like a sanctuary, far from the noise of everyday life.",
  date: '1 month ago'
}, {
  name: 'Radu P.',
  text: 'We came for a couples retreat and it exceeded all expectations. The jade massage bed was deeply relaxing, and the outdoor area with the fairy lights at night is simply stunning. Elena is a wonderful host.',
  date: '3 weeks ago'
}];
function Stars() {
  return <div className="flex gap-0.5" data-id="element-325">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-326" />)}
    </div>;
}
export function Reviews() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-cream py-24 md:py-32 px-6 lg:px-8" data-id="element-327">
      <div className="max-w-6xl mx-auto" ref={ref} data-id="element-328">
        {/* Header */}
        <motion.div className="text-center mb-16 md:mb-20" initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} data-id="element-329">
          <p className="text-sm font-body font-medium tracking-[0.25em] uppercase text-sage mb-4" data-id="element-330">
            Guest Experiences
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-semibold text-bark mb-6" data-id="element-331">
            What Our Guests Say
          </h2>

          {/* Google rating badge */}
          <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-warm-white shadow-sm" data-id="element-332">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" data-id="element-333">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-334" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-335" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-336" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-337" />
            </svg>
            <span className="font-heading text-lg font-semibold text-bark" data-id="element-338">
              5.0
            </span>
            <div className="flex gap-0.5" data-id="element-339">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" data-id="element-340" />)}
            </div>
            <span className="font-body text-sm text-bark-light" data-id="element-341">on Google</span>
          </div>
        </motion.div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-342">
          {reviews.map((review, i) => <motion.blockquote key={review.name} initial={{
          opacity: 0,
          y: 30
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1 + i * 0.1
        }} className="bg-warm-white rounded-2xl p-8 md:p-10" data-id="element-343">
              <Stars data-id="element-344" />
              <p className="font-body text-bark-light text-base md:text-lg leading-relaxed mt-5 mb-6" data-id="element-345">
                "{review.text}"
              </p>
              <div className="flex items-center justify-between" data-id="element-346">
                <div className="flex items-center gap-3" data-id="element-347">
                  <div className="w-10 h-10 rounded-full bg-sage/15 flex items-center justify-center" data-id="element-348">
                    <span className="font-heading text-sm font-semibold text-sage" data-id="element-349">
                      {review.name.charAt(0)}
                    </span>
                  </div>
                  <div data-id="element-350">
                    <p className="font-body text-sm font-medium text-bark" data-id="element-351">
                      {review.name}
                    </p>
                    <p className="font-body text-xs text-bark-light/60" data-id="element-352">
                      {review.date}
                    </p>
                  </div>
                </div>
              </div>
            </motion.blockquote>)}
        </div>

        {/* Link to all reviews */}
        <motion.div className="text-center mt-12" initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-353">
          <a href="https://www.google.com/maps/place/Zen+Barn+Spa/@46.0956121,24.4789571,725m/data=!3m1!1e3!4m18!1m9!3m8!1s0x474b87b38a979c77:0x137c29589a96c402!2sZen+Barn+Spa!8m2!3d46.0956121!4d24.481532!9m1!1b1!16s%2Fg%2F11mb67gqq7" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-body text-sm font-medium text-terracotta hover:text-terracotta-dark transition-colors duration-300" data-id="element-354">
            Read all reviews on Google
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-355">
              <path d="M7 17l9.2-9.2M17 17V7H7" data-id="element-356" />
            </svg>
          </a>
        </motion.div>
      </div>
    </section>;
}